// i18n area 'cluster' — locale pt-BR (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da cluster.pt-PT.ts e sovrascrive SOLO le chiavi
// che il brasiliano scrive davvero in un altro modo: lessico (usuário,
// arquivo, tela, senha, registro, seção, configurações, salvar, console) e
// morfologia verbale (il progressivo 'está a fazer' → 'está fazendo').
// DA RIVEDERE DA MADRELINGUA: restano fuori le scelte a bassa confidenza
// (alojar/hospedar, eliminar/excluir, arranque/inicialização) e la posizione
// dei clitici, che una regola meccanica non sa spostare.
// Sidecar anti-stantie: ../meta/cluster.pt-BR.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './cluster'

export const ptBR: DeepPartial<typeof enUS> = {
  cluster: {
    reducedHint: 'As suas permissões cobrem um scope, não o cluster inteiro: o inventário da frota — nós, configurações e dispositivos — só é visível para os administradores do cluster.',
    settingsTitle: 'Configurações',
    node: {
      tabSettings: 'Configurações locais'
    },
    colLastSeen: 'Último contato',
    revokeTitle: 'Revogar pré-registro',
    revokeError: 'Não foi possível revogar o registro',
    attestConfirm: 'Está declarando este nó desligado, por sua conta e risco: atestar um nó na verdade vivo arrisca VMs em execução dupla. As suas tasks são falhadas e as authorities das suas VMs tornam-se transferíveis.'
  },
  clusterDevices: {
    gpusSubtitle: 'O inventário de GPUs de todo o cluster agrupado por modelo — as placas observadas por nó, com os registros marcados e as suas tags',
    usbSubtitle: 'O inventário USB de todo o cluster agrupado por modelo — os dispositivos observados por nó, com os registros de ambos os modelos (por dispositivo, por porta) e as suas tags',
    colRegistration: 'Registro',
    noRegsHint: 'Nenhum registro — o dispositivo marca-se "utilizável pelo TVirt" no dialog do nó (Nós › nó › Configurações).',
    colRegs: 'Registros',
    manageOnNode: 'Gerenciar no nó {node} (a marcação vive no dialog do nó)',
    introStep2: '2. Um dispositivo marca-se "utilizável pelo TVirt" no dialog do NÓ (Nós › nó › Configurações) — a marcação liga-o ao vfio e regista-o aqui.',
    introStep3: '3. Aqui dão-se aos registros as suas CLASSES via tags (ex. gpu_class=compute): os requisitos das VMs pedirão uma classe, e o scheduler escolherá um nó com um dispositivo livre compatível.',
    orphanPortsTitle: 'Registros por porta sem dispositivo ligado — volte a ligar um dispositivo ou desmarque-os no nó'
  },
  settings: {
    passwordMinLength: 'Comprimento mínimo da senha',
    save: 'Salvar',
    saved: 'Configurações salvas',
    saveError: 'Não foi possível salvar as configurações'
  },
  localSettings: {
    // R5 (gap G2): il brasiliano scrive 'chassi' dove il pt-PT tiene 'chassis'.
    placementLevel: {
      chassis: 'Chassi'
    },
    nodeSettingsTitle: 'Configurações do nó',
    nodeSettingsSubtitle: 'O que este nó aplica — fila de tasks, console, reencaminhamento de logs — mais as suas tags e as notas',
    placementHint: 'O posicionamento guia a hierarquia CRUSH de cada cluster Ceph com um OSD neste servidor: salvar uma alteração realinha os seus mapas via task (host → rack → … → root). As declarações parciais são legais — os níveis vazios simplesmente colapsam. Os nomes são partilhados por todo o mapa: dois servidores no mesmo rack declaram o mesmo nome de rack.',
    dataDisksHint: 'Assinalar um dispositivo declara-o utilizável como OSD; o número de série é o seu pin de identidade — copiado do hardware quando o disco o reporta, cunhado (tvirt-…) caso contrário. O dialog de registro Ceph oferece apenas os discos declarados.',
    passthroughOrphan: 'órfão — registado mas já não detectado: volte a ligá-lo ou desmarque-o',
    nicsSubtitle: 'O registro das NICs geridas — registar É a declaração de gestão: uma NIC registada sem configuração não é tocada (clear-if declara-a explicitamente limpa), um dispositivo não registado nunca é tocado',
    delNicConfirm: 'A gestão de {name} termina: a entrada do registro e a sua configuração são eliminadas e o perfil TVirt removido — o dispositivo fica tal como o Linux o tem.',
    noManagedDevices: 'Nenhum dispositivo gerido — registe primeiro uma NIC, tudo se constrói sobre o registro',
    editBond: 'Salvar bond',
    editBridge: 'Salvar bridge'
  }
}
